import { render, staticRenderFns } from "./SpeciesLayout.vue?vue&type=template&id=1d1322a4"
import script from "./SpeciesLayout.vue?vue&type=script&lang=js"
export * from "./SpeciesLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports